import { Grid } from '@material-ui/core';
import { EmbeddableWorkflow } from '@backstage/plugin-scaffolder-react/alpha';

import { useEntity } from '@backstage/plugin-catalog-react';
import { getKratixTemplateName } from '../../utils/utils';
import {
  scaffolderApiRef,
  ScaffolderFieldExtensions,
  useCustomFieldExtensions,
} from '@backstage/plugin-scaffolder-react';
import { EntityPickerFieldExtension } from '@backstage/plugin-scaffolder';
import { ae360ScaffolderExtensions } from '@internal/acc-react-shared';
import { alertApiRef, useApi } from '@backstage/core-plugin-api';
import { useNavigate } from 'react-router-dom';
import { Progress } from '@backstage/core-components';
import { useSquadFormState } from './SquadManager-hooks';

const extensionSet = (
  <ScaffolderFieldExtensions>
    {ae360ScaffolderExtensions()}
    <EntityPickerFieldExtension />
  </ScaffolderFieldExtensions>
);

export function SquadManager() {
  const scaffolderAPI = useApi(scaffolderApiRef);
  const alertApi = useApi(alertApiRef);
  const { entity } = useEntity();
  const navigate = useNavigate();
  const extensions = useCustomFieldExtensions(extensionSet);
  const templateName = getKratixTemplateName(entity);
  const { loading, value, error } = useSquadFormState(entity);

  const create = async (values: any) => {
    try {
      const result = await scaffolderAPI.scaffold({
        values: values,
        templateRef: `template:default/${templateName}`,
      });
      navigate(`/create/tasks/${result.taskId}`);
    } catch (err: any) {
      alertApi.post({
        severity: 'error',
        message: `Failed to schedule scaffold  ${err?.message}`,
      });
    }
  };

  if (loading) {
    return <Progress />;
  }
  if (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return <div>Error :{error.message}</div>;
  }
  return (
    <>
      <Grid container spacing={3} direction="column">
        <Grid item>
          <EmbeddableWorkflow
            initialState={value}
            templateName={templateName}
            namespace="default"
            onError={err => <span>Error {err?.message}</span>}
            extensions={extensions}
            onCreate={create}
          />
        </Grid>
      </Grid>
    </>
  );
}
